import React from "react";
import { siteUrl } from "../utils/constants";
import type { SponsorEntity } from "../types/strapi";
import RenderLoader from "./common/RenderLoader";
import { mediaUrl } from "../utils/imageUtils";

interface BrandTwoProps {
  sponsors: SponsorEntity;
}

const BrandTwo: React.FC<BrandTwoProps> = ({ sponsors }) => (
  <div className="rn-brand-area bg_color--1 ptb--120">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="section-title text-center mb--30">
            <span className="subtitle">
              {sponsors?.superHeadingOne ?? ""}
            </span>
            <h3 className="title">
              {sponsors?.headingOne ?? ""}
            </h3>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <ul className="brand-style-2">
            {sponsors?.image !== undefined &&
            sponsors?.image !== null ? (
              sponsors.sponsors?.map((item: any, index: number) => (
                <li key={`sponsors${index}`}>
                  <img
                    src={mediaUrl(item.formats.thumbnail.url)}
                    alt={`Cultural Ecologies sponsor no.${index}`}
                  />
                </li>
              ))
            ) : (
              <RenderLoader />
            )}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default BrandTwo;
